    import {Component, Inject} from 'ng-metadata/core';
    import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
    import {JournalsService} from "../../journals/journals.service";
    import {MediaQueries} from "../../infra/mediaQueries.service";

    @Component({
        "selector": "prm-topbar",
        templateUrl: 'components/search/topbar/topbar.html'
    })

    export class PrmTopbar {
        private showMainMenu: boolean;
    	private displayFavorites: boolean = true;

        constructor(@Inject('$state')private $state: ng.ui.IStateService,
                    private configurationUtil: ConfigurationUtil,
                    private journalsService: JournalsService,
                    private mediaQueries: MediaQueries) {
            this.showMainMenu = true;
            if(this.isSummonOverAlma()){
                this.displayFavorites = false;
                this.showMainMenu = false;
            }
            if(this.isServicePage()){
                this.showMainMenu = false;
			}
            if(this.isDeposit()){
                this.showMainMenu = false;
                this.displayFavorites = false;
            }
            if(this.isDiscoveryServicesPage()){
                this.showMainMenu = false;
            }
        }
        private isSummonOverAlma() :boolean{
            return this.configurationUtil.getBackendSystem() === 'suprima' && this.configurationUtil.getSummonOverAlma();
        }

        private isDiscoveryServicesPage() :boolean{
            return this.configurationUtil.getBackendSystem() === 'suprima' && this.configurationUtil.getDiscoveryServicesPage();
        }

        private isServicePage() : boolean {
            return this.$state.current.name === 'servicesPage';
        }

        private isDeposit() : boolean {
            return this.$state.current.name === 'deposit' || this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery';
        }
        private isViewer() : boolean {
            return this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery';
        }
        get isRapidoSAEnabled(){
            return this.configurationUtil.getRapidoSAEnabled()
        }
    }





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/topbar.directive.ts